import type { EditorTool } from '../sim/map/index.ts';
import {
  CURSOR_ARROW,
  CURSOR_ARROW_HOVER,
  CURSOR_ERASER,
  CURSOR_ERASER_HOVER,
  CURSOR_FLAG,
  CURSOR_FLAG_HOVER,
} from './cursors.ts';

const DRAW_TOOLS: ReadonlySet<EditorTool> = new Set([
  'draw-island',
  'draw-rock',
  'draw-terrace',
  'draw-water',
  'draw-route',
]);

/**
 * Canvas cursor for a non-pan editor tool. Hand / Space / pan stay in
 * `EditorScene.syncCursor` (grab / grabbing).
 */
export function cursorForEditorTool(tool: EditorTool): string {
  if (DRAW_TOOLS.has(tool)) {
    return 'crosshair';
  }

  if (tool === 'place-checkpoint') {
    return CURSOR_FLAG;
  }

  if (tool === 'erase-prop') {
    return CURSOR_ERASER;
  }

  // select, scale, rotate, place-prop, edit-start-area — and hand is overridden above.
  return CURSOR_ARROW;
}

/**
 * Hover twin for the active tool — black fill of the same glyph, or crosshair.
 * Used for Phaser interactive handles and for CSS `cursor: pointer` overrides.
 */
export function hoverCursorForEditorTool(tool: EditorTool): string {
  if (DRAW_TOOLS.has(tool)) {
    return 'crosshair';
  }

  if (tool === 'place-checkpoint') {
    return CURSOR_FLAG_HOVER;
  }

  if (tool === 'erase-prop') {
    return CURSOR_ERASER_HOVER;
  }

  return CURSOR_ARROW_HOVER;
}
